// extracted by mini-css-extract-plugin
export default {"formButton":"SearchForm_formButton__SEitT","formInput":"SearchForm_formInput__f-7yZ"};